export const classes = {
  wrapper: 'pb-4 place-between',
  controls: 'place-end',
  content: 'flex items-center',
  info: 'mr-2 place-center',
  title: 'mr-1 text-xl text-grey-8 dark:text-mauve-1 font-semibold',
  addButton: 'normal-case font-semibold',
  activeBadge: 'mr-4',
  inactiveBadge: 'mr-3',
  iconButton:
    'transition-all cursor-pointer text-grey-6 dark:text-mauve-3 hover:text-grey-7 dark:hover:text-mauve-2 ml-3',
  activeFilters:
    'active-filters text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1',
};
